'use client';

import { useTranslation } from 'next-i18next';
import { PhoneIcon } from '@heroicons/react/24/outline';
import { Button, Tooltip } from '@components/common';
import { showPhoneApplyModal } from './PhoneApplyModal';

interface PhoneApplyButtonProps {
  locale: Locale;
  jobSlug: string;
}

/**
 * @description Circular phone-icon button rendered next to the apply
 * button on the public job detail page. Visible to guests only — the
 * caller in JobActions.tsx gates on `!isSafeAuth`.
 *
 * Opens PhoneApplyModal on click. See docs/plans/phone-apply-flow.md.
 */
export const PhoneApplyButton = (props: PhoneApplyButtonProps) => {
  const { locale, jobSlug } = props;
  const { t } = useTranslation('common');

  const tooltipText = t('phone_apply.button.tooltip', 'Apply by phone');

  return (
    <Tooltip
      tooltipText={tooltipText}
      position="top"
      colorScheme="black"
      floating
      useFloatingPortal
    >
      <Button
        color="secondary"
        styling="outline"
        rounding="full"
        className="!p-2"
        size="sm"
        aria-label={tooltipText}
        onClick={() => showPhoneApplyModal({ locale, jobSlug })}
      >
        <PhoneIcon className="size-5" />
      </Button>
    </Tooltip>
  );
};
